module.exports = __webpack_public_path__ + "static/media/logo.426c117b.png";